import {Navigate, useLocation} from "react-router";
import {JSX} from "react";
import {getCookie} from "../utils/getCookie";


export default function RequireAuth({ children }: { children: JSX.Element }) {
    const isAuthenticated = getCookie("sid") &&  getCookie("sid") != "Guest"
    const location = useLocation()

    if (isAuthenticated) {
        return <Navigate to="/auth/login" state={{ from: location }} replace />;
    }

    return children;
}
